/**
 * "x ago" wrapper around `date-fns` for the Integrations surfaces (the Status
 * Data panel + the section shell). Returns `fallback` when there's no timestamp,
 * and the raw string if it can't be parsed - so it's always safe to render.
 */
import { formatDistanceToNow, parseISO } from 'date-fns'

export const relativeTime = (
  iso?: string | null,
  fallback = 'Never',
): string => {
  if (!iso) return fallback
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true })
  } catch {
    return iso
  }
}
